import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const MultiActionButtonWrapper = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border: none;
  background-color: ${(p) => p.theme.colors.white};
  border-radius: 4px;
  &:hover,
  &:focus {
    outline: none;
    background-color: ${(p) => p.theme.colors.primary95w};
  }
`;

export const MultiActionButtonDot = styled.span`
  border-radius: 50%;
  height: 4px;
  width: 4px;
  margin: 2px;
  background-color: ${(p) => p.theme.colors.primary20b};
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15px 0;
  margin-top: 5px;
  border: 1px solid ${(p) => p.theme.colors.secondary90w};
  border-radius: 4px;
  background-color: ${(p) => p.theme.colors.white};
  z-index: 10;
`;

export const Action = styled.button`
  border: none;
  background-color: transparent;
  width: 100%;
  padding: 7px 25px;
  text-align: left;

  span {
    color: ${(p) => (p.disabled ? p.theme.colors.secondary60w : 'unset')};
  }

  ${(p) =>
    !p.disabled &&
    css`
      &:hover {
        background-color: ${p.theme.colors.primary95w};
      }

      &:focus {
        outline: none;
        background-color: ${p.theme.colors.primary95w};
      }
    `}
`;

export const ActionLink = styled(Link)`
  border: none;
  background-color: transparent;
  width: 100%;
  padding: 7px 25px;
  text-align: left;

  &:hover {
    background-color: ${(p) => p.theme.colors.primary90w};
  }

  &:focus {
    outline: none;
    background-color: ${(p) => p.theme.colors.primary95w};
  }
`;
